import { Controller } from '@hotwired/stimulus';
import callApi from '../common/AjaxUtil';

export default class extends Controller {
  static targets = ['like'];

  static values = { issueId: Number };

  create() {
    const body = { issueId: this.issueIdValue };
    callApi('/ajax/send_like', 'POST', body)
      .then(() => {
        location.reload();
      })
      .catch((err) => {
        window.$sendAlert(err.msg);
      });
  }

  async cancel() {
    callApi('/ajax/cancel_like', 'POST', { issueId: this.issueIdValue })
      .then(() => {
        location.reload();
      })
      .catch((err) => {
        window.$sendAlert(err.msg);
      });
  }

  async callApi(url, like, method) {
    const response = await fetch(_spring['context_path'] + url, {
      method,
      credentials: 'include',
      headers: Object.assign({}, _csrf, {
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(like),
    });

    if (!response.ok) {
      window.$sendAlert('오류가 발생했습니다.');
      return false;
    }
    return true;
  }

  async cancelApi(url, like, method) {
    const response = await fetch(_spring['context_path'] + url, {
      method,
      credentials: 'include',
      headers: Object.assign({}, _csrf, {
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(like),
    });

    if (!response.ok) {
      window.$sendAlert('오류가 발생했습니다.');
      return false;
    }
    return true;
  }
}
